import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PlayAudioService {
  playAudioParser(content: string): string {
    return content.replace(/\[playAudio\s+([^\]]+)\]/g, (match, attributes) => {
      const url = this.extractAttribute(attributes, 'url');
      const label = this.extractAttribute(attributes, 'label');

      if (!url) return match;

      const escapedUrl = this.escapeAttribute(url);
      const escapedLabel = this.escapeAttribute(label || 'Play Sample');

      return `<div class="play-audio-placeholder"
                   data-component="playAudio"
                   data-url="${escapedUrl}"
                   data-label="${escapedLabel}">
              </div>`;
    });
  }

  private extractAttribute(attributes: string, name: string): string {
    // Handle escaped quotes from Craft CMS Redactor (e.g. url=\"value\")
    const escapedMatch = attributes.match(new RegExp(`${name}=\\\\"([^"]+)\\\\"`));
    if (escapedMatch) return escapedMatch[1];

    // Handle plain quotes (standard format: url="value")
    const plainMatch = attributes.match(new RegExp(`${name}="([^"]+)"`));
    if (plainMatch) return plainMatch[1];

    return '';
  }

  private escapeAttribute(text: string): string {
    if (!text) return '';
    return text
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
}
